import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/adminPage/procedures/parentalLeave/index'
import {Request} from 'pages/withAuth/adminPage/procedures/parentalLeave/request'
import {ParentalLeaveFlow} from 'pages/withAuth/adminPage/procedures/parentalLeave/flow'
import {Confirm} from 'pages/withAuth/adminPage/procedures/parentalLeave/confirm'

export const ParentalLeaveRoutes: RouteParams[] = [
  {
    key: 'parental_leave',
    path: WITH_AUTH_ADMIN_PATHS.PARENTAL_LEAVE.INDEX,
    component: Index,
    exact: true,
  },
  {
    key: 'parental_leave/request',
    path: WITH_AUTH_ADMIN_PATHS.PARENTAL_LEAVE.REQUEST,
    component: Request,
    exact: true,
  },
  {
    key: 'parental_leave/flow/:id',
    path: WITH_AUTH_ADMIN_PATHS.PARENTAL_LEAVE.FLOW,
    component: ParentalLeaveFlow,
    exact: true,
  },
  {
    key: 'parental_leave/confirm/:id',
    path: WITH_AUTH_ADMIN_PATHS.PARENTAL_LEAVE.CONFIRM,
    component: Confirm,
    exact: true,
  },
]
